/**
 * JavaScript for front-end navigation functionality.
 */

// Scroll Event Listener - toggle header background based on scroll
window.addEventListener('scroll', () => {
    const header = document.querySelector('.header');
    const container = document.querySelector('.container');
    if (header && container) {
        const isScrolled = window.scrollY > 0;
        header.classList.toggle('scrolled', isScrolled);
        container.classList.toggle('scrolled', isScrolled);
    }
});

// Burger menu button and mobile menu handling
const burgerButton = document.getElementById('burger-button');
const mobileMenu = document.getElementById('mobile-menu');
const header = document.querySelector('.header');

// Function to set the mobile menu's top position based on header's height
function updateMenuTop() {
    if (header && mobileMenu) {
        const headerHeight = header.offsetHeight;
        mobileMenu.style.top = `${headerHeight}px`;
        mobileMenu.style.height = `calc(100vh - ${headerHeight}px)`;
    }
}

// Toggle function for mobile menu and burger button animation
function toggleMenu() {
    if (mobileMenu && burgerButton) {
        mobileMenu.classList.toggle('active');
        burgerButton.classList.toggle('open'); // Toggles animation class on burger button
        updateMenuTop(); // Ensure menu is positioned correctly

        // Header background toggle
        if (mobileMenu.classList.contains('active')) {
            header.classList.add('menu-open');
        } else if (!window.scrollY) {
            header.classList.remove('menu-open');
        }
    }
}

// Update menu position on window resize and load
window.addEventListener('resize', updateMenuTop);
window.addEventListener('load', () => {
    updateMenuTop();

    // Check initial scroll position to apply "scrolled" class
    const header = document.querySelector('.header');
    const container = document.querySelector('.container');
    if (header && container) {
        const isScrolled = window.scrollY > 0;
        header.classList.toggle('scrolled', isScrolled);
        container.classList.toggle('scrolled', isScrolled);
    }
});

// Add event listener to burger button to toggle menu
if (burgerButton) {
    burgerButton.addEventListener('click', toggleMenu);
}

// Scroll Event Listener (to ensure consistent header behavior while scrolling)
window.addEventListener('scroll', () => {
    const isScrolled = window.scrollY > 0;
    if (header) {
        header.classList.toggle('scrolled', isScrolled);

        if (!isScrolled && mobileMenu && !mobileMenu.classList.contains('active')) {
            header.classList.remove('menu-open');
        }
    }
});

// Event Listeners för menu-item och submenu-item
const menuItems = document.querySelectorAll('.menu-item');
const submenuItems = document.querySelectorAll('.submenu-item');

// Hantera click events för nivå 1 (menu-item)
menuItems.forEach(item => {
    const mainLink = item.querySelector('.main-link');
    const link = item.querySelector('.main-link a');
    const dropdownToggle = item.querySelector('.dropdown-toggle');

    if (mainLink) {
        mainLink.addEventListener('click', function (e) {
            // Förhindra stängning om det är länken som klickas
            if (e.target === link) return;

            e.preventDefault();
            const submenu = item.querySelector('.submenu');
            if (submenu) {
                item.classList.toggle('active');
            }
        });
    }

    if (link) {
        link.addEventListener('click', function (e) {
            e.stopPropagation(); // Förhindra att menyn stängs vid klick på länken
        });
    }
});

// Hantera click events för nivå 2 (submenu-item)
submenuItems.forEach(item => {
    const submenuLink = item.querySelector('.submenu-link');
    const link = item.querySelector('.submenu-link a');
    const dropdownToggle = item.querySelector('.submenu-dropdown-toggle');

    if (submenuLink) {
        submenuLink.addEventListener('click', function (e) {
            // Förhindra stängning om det är länken som klickas
            if (e.target === link) return;

            e.preventDefault();
            const megamenu = item.querySelector('.megamenu');
            if (megamenu) {
                item.classList.toggle('active');
            }
        });
    }

    if (link) {
        link.addEventListener('click', function (e) {
            e.stopPropagation(); // Förhindra att menyn stängs vid klick på länken
        });
    }
});

// Stop submenu links from closing the parent menu
const submenuLinks = document.querySelectorAll('.submenu a');
submenuLinks.forEach(submenuLink => {
    submenuLink.addEventListener('click', function(e) {
        e.stopPropagation();
    });
});

document.addEventListener('DOMContentLoaded', () => {
    const searchDropdown = document.querySelector('.search-dropdown');
    const searchIcon = document.querySelector('.search-icon');
    const searchInput = document.querySelector('.search-input'); // Input-fältet
    const navItems = document.querySelectorAll('.nav-item'); // Navigationsobjekt

    if (searchDropdown && searchIcon && searchInput) {
        // Hantera klick på sökikonen
        searchIcon.addEventListener('click', (e) => {
            e.preventDefault();
            searchDropdown.classList.toggle('active'); // Växla mellan öppen/stängd
            if (searchDropdown.classList.contains('active')) {
                setTimeout(() => {
                    searchInput.focus(); // Försök sätta fokus med fördröjning
                }, 100); // Fördröjning på 100 ms
            }
        });

        // Stäng sök-dropdown om användaren klickar utanför
        document.addEventListener('click', (e) => {
            if (!searchDropdown.contains(e.target) && !searchIcon.contains(e.target)) {
                searchDropdown.classList.remove('active');
            }
        });

        // Stäng sök-dropdown när en nav-item hovras över
        navItems.forEach(item => {
            item.addEventListener('mouseenter', () => {
                searchDropdown.classList.remove('active'); // Stänger sök-dropdownen
            });
        });
    }
});

document.addEventListener('DOMContentLoaded', function () {
    const button = document.querySelector('.wpml-button-mb');
    const dropdown = document.querySelector('.wpml-header-dropdown');

    if (button && dropdown) {
        // Visa/Göm dropdown vid klick
        button.addEventListener('click', function (e) {
            e.stopPropagation(); 
            dropdown.classList.toggle('active');
            button.classList.toggle('active');
        });

        // Klick utanför stänger dropdown
        document.addEventListener('click', function (e) {
            if (!dropdown.contains(e.target) && !button.contains(e.target)) {
                dropdown.classList.remove('active');
                button.classList.remove('active');
            }
        });
    }
});

//Darkmode logic
const toggle = document.getElementById("theme-toggle");

if (toggle) {
  const html = document.documentElement;

  const getSystemPref = () =>
    window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";

  const applyTheme = (theme) => {
    html.setAttribute("data-theme", theme);
    toggle.checked = theme === "dark";
  };

  const setUserPreference = (theme) => {
    localStorage.setItem("theme", theme);
    localStorage.setItem("system-overridden", "false");
    applyTheme(theme);
  };

  // Init: system preference
  const systemPref = getSystemPref();
  const savedTheme = localStorage.getItem("theme");
  const overridden = localStorage.getItem("system-overridden") !== "false";

  if (!savedTheme) {
    localStorage.setItem("theme", systemPref);
    localStorage.setItem("system-overridden", "true");
    applyTheme(systemPref);
  } else if (overridden) {
    applyTheme(systemPref);
  } else {
    applyTheme(savedTheme);
  }

  toggle.addEventListener("change", () => {
    const theme = toggle.checked ? "dark" : "light";
    setUserPreference(theme);
  });

  window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", (e) => {
    const newSystemPref = e.matches ? "dark" : "light";

    // Simulera användarändring för animation
    toggle.checked = newSystemPref === "dark";
    toggle.dispatchEvent(new Event("change", { bubbles: true }));

    localStorage.setItem("system-overridden", "true");
  });
}